import * as petRuleset from './pet.ruleset';
import { petSchema } from './pet.schema';
import { petGetters } from './pet.getters';
import { petModifiers } from './pet.modifiers';
import { petActions } from './pet.actions';
import { petMessages } from './pet.messages';
import { petProperties } from './pet.properties';
import { petAsyncGetters } from './pet.asyncGetters';
import { ReplicantModuleState } from '../../utils';
import { Encyclopedia } from '../../encyclopedia';
import { userSettingsSchema } from '../../state/settings';
import { VisitRecord } from '../../visit/record';
import { PetStats } from './stats';
import { Inventory } from '../inventory';
import { Level } from '../level';
import { History } from '../history';
import fateSchema from '../fate/fate.schema';
import * as fateGetters from '../fate/fate.getters';
import * as fateModifiers from '../fate/fate.modifiers';
import * as fateStatus from '../fate/fate.status';
import { Immutable } from '@play-co/replicant';
import features from '../../ruleset/features';

export type {
  PetAttribute,
  PetStatusEffect,
  PetState,
  PetEvolutionStage,
  PetEvolution,
  PetSpecies,
} from './pet.ruleset';

namespace Fate {
  export const schema = fateSchema;
  export const api = {
    ...fateGetters,
    ...fateModifiers,
    ...fateStatus,
  };
}

namespace Settings {
  export const schema = { settings: userSettingsSchema };
}

export type Pet = typeof Pet;
// eslint-disable-next-line no-redeclare
export namespace Pet {
  export const $DEPENDENCIES = {
    PetStats,
    Fate,
    VisitRecord,
    Inventory,
    Level,
    Encyclopedia,
    Settings,
    History,
  };

  export const ruleset = petRuleset;
  export const schema = petSchema(Pet);
  export const getters = petGetters(Pet, $DEPENDENCIES, features);
  export const asyncGetters = petAsyncGetters(Pet);
  export const properties = petProperties(Pet);
  export const modifiers = petModifiers(Pet, $DEPENDENCIES);
  export const messages = petMessages(Pet, $DEPENDENCIES);
  export const actions = petActions(Pet, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Pet>;
  export type State = Immutable<MutableState>;
  export type Evolution = {
    species: petRuleset.PetSpecies;
    stage: petRuleset.PetEvolutionStage;
    timestamp: number;
  };
}
